import React, { useState } from 'react'
import "./contact.css"
import Button from '../../componets/Button'
import contactImg from "../../images/contact5.jpg"
import { FaWhatsapp, FaPhone } from 'react-icons/fa';

const Contact = () => {
  const [error, setError] = useState("")
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  })

  const handleForm = (e) => {
    const {value, name } = e.target;
    setFormData(oldData => {
      return {
        ...oldData,
        [name]: value
      }
    })
  }

  const getData = (e) => {
    e.preventDefault()
    if(!formData.name || !formData.email || !formData.message){
      setError("Kindly fill all fields")
      setTimeout(() => {
        setError("")
      }, 3000);
      return;
    }

    const message = `Name: ${encodeURIComponent(formData.name)}
    Email: ${encodeURIComponent(formData.email)}
    Message: ${encodeURIComponent(formData.message)}`;
    
    const mailtoLink = `mailto:aremudami58@gmail.com?subject=Contact Form Submission&body=${message}`;
    
    window.location.href = mailtoLink;

    setFormData({
      name: "",
      email: "",
      message: ""
    })
  }

  return (
    <section className="contact-section">
      <h2 className="contact-head">Contact Us</h2>

      <p className="contact-info">
        Have any questions or inquiries? Fill out the form below and we'll get
        back to you as soon as possible.
      </p>
      
      {error && <div className="error-message">{error}</div> }
      <form className="contact-form" onSubmit={getData}>
        <div className="name-container">
          <label htmlFor="name">Name</label>
          <input 
            type="text" 
            id="name"
            name="name"
            placeholder="Your name" 
            value={formData.name} 
            onChange={handleForm} 
          />
        </div>

        <div className="email-container">
          <label htmlFor="email">Email</label>
          <input 
            type="email" 
            id="email" 
            name="email"
            placeholder="example@gmail.com" 
            value={formData.email} 
            onChange={handleForm} 
          />
        </div>

        <div className="message-container">

          <label htmlFor="message">Message</label>
          <textarea 
            id="message" 
            name="message"
            placeholder="Enter your message" 
            rows="7" 
            value={formData.message} 
            onChange={handleForm}
          />
        </div>

        <div className="form-btn-container">
          <Button text={"Submit"} className={"form-btn"} />
        </div>
      </form>

      <center>
        <div className="contact-bridge">or</div>
      </center>

      <aside className="contact-aside">
        <div className="contact-img">
          <div className="img-text">
            <p>Get in touch</p>
            <span>Want to get in touch? We'd love to hear from you. Here's how you can reach us -</span>
          </div>
          {/* <img src={"https://firebasestorage.googleapis.com/v0/b/fir-login-33c28.appspot.com/o/file%2Freal2.jpg?alt=media&token=41fa3f4a-4a04-4ed2-a7df-9ad21632ec40"} alt="support"/> */}
          <img src={contactImg} alt="support"/>
        </div>

        <div className="contact-details">
          
          <div className="contact-phone">
            <h4><FaPhone /></h4>
            <p>Talk to us via phone</p>
            <small>We'll help you find the perfect properties and pricing for your real estate needs.</small>
            <a href="tel:++2348156959983" className="contact-link"> Call</a>
          </div>

          <div className="contact-whatsapp">
            <h4><FaWhatsapp /></h4>
            <p>Talk to us via whatsapp</p>
            <small>We'll help you find the perfect properties and pricing for your real estate needs.</small>
            <a href="https://wa.me/+2348156959983" className="contact-link">WhatsApp</a>
          </div>

        </div>

        <div className="contact-bottom">
          <center> 
            <small>Just send us your questions or concern by starting a message and we will give the help you need.</small>
          </center>
        </div>
      </aside>
    </section>
  );
}

export default Contact
